import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';

const CompetitionWorkSeniorityEditDialog = (props) => {
    const [competition, setCompetition] = useState(null);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setCompetition( {...props?.value, workSeniority: props?.value?.workSeniority !== null ? props?.value?.workSeniority : 0 });     
    }, [props.value]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: competition,
        validate: (data) => {
            let errors = {};

            if(data.workSeniorityRequired && data.workSeniority === null) {
                errors.workSeniority = translatedMessage('form.error.competition.workSeniority.required');
            }

            return errors;
        },
        onSubmit: (data) => {
            // console.log(data);
            saveCompetition(data);
        }
    });

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const saveCompetition = (data) => {
        competitionService.saveCompetitionJob(data)
            .then((savedTest) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedTest, true);
                }
                hideDialog();
                formik.resetForm();
            })
            .catch((error) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(null, false, error);
                }
            });
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="workSeniority-form" type="submit" />
        </>
    );

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.visible}
                style={{ width: '450px' }}
                header={translatedMessage('competition.requirements.work')}
                modal
                className="p-fluid"
                footer={dialogFooter}
                onHide={hideDialog}
            >
                <form id="workSeniority-form" onSubmit={formik.handleSubmit}>
                    <div className="field-checkbox text-left mb-5">
                        <Checkbox inputId="workSeniorityRequired" name="workSeniorityRequired" checked={formik.values?.workSeniorityRequired}
                            onChange={formik.handleChange} />
                        <label htmlFor="workSeniorityRequired">{translatedMessage("competition.requirements.work.required")}</label>
                    </div>

                    <div className="field p-inputgroup">
                        <span className="p-float-label">
                            <InputText type="text" name="workSeniority" id="workSeniority"
                                value={formik.values?.workSeniority} onChange={formik.handleChange}
                                className={classNames({ 'p-invalid': isFormFieldValid('workSeniority') })}
                                keyfilter="int" maxLength={2}/>
                            <label htmlFor="workSeniority" className={classNames({ 'p-error': isFormFieldValid('workSeniority') })}>
                                {translatedMessage("competition.requirements.work.info")} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('workSeniority')}


                </form>
            </Dialog>
        </>
    );
};

export default CompetitionWorkSeniorityEditDialog;
